import PropTypes from 'prop-types';
import React from 'react';

const CircleProgressBar = ({ currentStep, totalSteps }) => {
  const progressPercentage = (currentStep / totalSteps) * 100;
  const strokeDasharray = `${progressPercentage} 100`;

  return (
    <div className='progress-circle-container'>
      <svg className='progress-circle' viewBox='0 0 36 36'>
        <circle className='progress-circle-background' cx='18' cy='18' r='16' />
        <circle
          className='progress-circle-progress'
          cx='18'
          cy='18'
          r='16'
          style={{ strokeDasharray }}
        />
      </svg>
      <div className='progress-circle-text'>
        {currentStep} of {totalSteps}
      </div>
    </div>
  );
};

CircleProgressBar.propTypes = {
  currentStep: PropTypes.number.isRequired,
  totalSteps: PropTypes.number.isRequired,
};

export default CircleProgressBar;
